"use client";

export {
  PostHogFeature,
  useActiveFeatureFlags,
  useFeatureFlagEnabled,
  useFeatureFlagPayload,
  useFeatureFlagResult,
  useFeatureFlagVariantKey,
  usePostHog,
} from "posthog-js/react";
export type { PostHogFeatureProps } from "posthog-js/react";
